module.exports = __webpack_public_path__ + "static/img/bg-ar.f0e0a59e.webp";